/**
 * Abstracting implementation for getting Environment
 */
export const getEnv = () => /*window.__APP_ENV__ ||*/ 'local-dev';

export const setDevFavicon = () => {
  const favicons = document.querySelectorAll('link[rel*="icon"]');
  for (const favicon of favicons) {
    // 'Element' type definition is empty for react. See cassi/node_modules/@types/react:26
    // @ts-ignore - Property 'href' does not exist on type 'Element'.
    favicon.href = favicon.href.replace('prod', 'dev');
  }
};
